import type { PropsWithChildren } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { ProfileResponse } from '@app/shared';
import { EntryScreen } from './EntryScreen';

/** A person who is not in yet sees only the entry screen (the daily quota, or the waitlist). */
export function RequireAccess({ children }: PropsWithChildren) {
  const { data } = useQuery<ProfileResponse>({ queryKey: ['profile'], enabled: false });
  if (!data) return null;
  if (!data.user.hasAccess) return <EntryScreen />;
  return <>{children}</>;
}
